(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["copyright"]) return;
  try {
    
    // Convert copyright year to roman
    var copyrightYearElem = document.querySelector('#copyright_year');
    var copyrightYear = copyrightYearElem.innerHTML;
    console.log('ROMAN DATE');
    copyrightYearElem.innerHTML = Shopify.formatNumberToRoman(copyrightYear);
  
  } catch(e) { console.error(e); }
})();
})();
